import React, { useState } from 'react';
import styled from 'styled-components';
import { IconButton, Popover, Text } from '@oneaudi/unified-web-components';
import { DangerousElement } from '../../../../../components';
import { dynamicStylingHelper, parseWithLinks } from '../../../../utils';
import { StyleUnstyledHTML } from '../../../../utils/StyleUnstyledHTML.style';
export const CustomPrice = ({ price, index, isLastItem }) => {
    const [popOverOpen, setPopOverOpen] = useState(false);
    const onTriggerClick = () => setPopOverOpen(!popOverOpen);
    const onClosePopover = () => setPopOverOpen(false);
    return (React.createElement(CustomPriceWrapper, { isLastItem: isLastItem },
        React.createElement(Text, { tag: "p", variant: { order: '2', style: 'normal' } },
            parseWithLinks(price === null || price === void 0 ? void 0 : price.label),
            ": ", price === null || price === void 0 ? void 0 :
            price.price,
            " ", price === null || price === void 0 ? void 0 :
            price.additionalPriceText),
        (price === null || price === void 0 ? void 0 : price.infoIcon) && (React.createElement(Popover, { content: React.createElement(Text, { tag: "p", variant: { order: '2', style: 'normal' } },
                React.createElement(StyleUnstyledHTML, null,
                    React.createElement(DangerousElement, { html: price === null || price === void 0 ? void 0 : price.infoIcon }))), "data-testid": "test-id", id: `price-popover-${index}`, triggerElement: React.createElement(IconButton, { "aria-label": price === null || price === void 0 ? void 0 : price.infoIconAriaLabel, icon: "info-circle", id: "fixed-trigger", onClick: onTriggerClick, size: dynamicStylingHelper('sm', 'xs'), variant: "tertiary" }), open: popOverOpen, onClose: onClosePopover }))));
};
const CustomPriceWrapper = styled.div `
  margin-top: ${({ isLastItem }) => (isLastItem ? '12px' : '0')};
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 36px;
`;
